export const DISALLOWED_IP_LIST = ['0.0.0.0', '127.0.0.1']
